export const fnResetFields = (getValues, setValue) => {
  const fieldCards = [
    { key: "card_number", value: null },
    { key: "card_cvv", value: null },
    { key: "card_expiration_date", value: null },
  ];

  const fieldPSE = [
    { key: "bank", value: null },
    { key: "account_number", value: null },
    { key: "account_type", value: null },
  ];

  const paymentType = getValues("payment_type");

  if (paymentType === "card") {
    fieldCards.forEach((fld) => {
      setValue(fld.key);
    });
  }
  if (paymentType === "pse") {
    fieldPSE.forEach((fld) => {
      setValue(fld.key);
    });
  }
};

export const fnSettingValueUser = (
  documents,
  infoUser,
  setValue,
  setInputValue
) => {
  const document = documents.filter(
    (el) => el?.name?.toUpperCase() === infoUser.doc_type?.toUpperCase()
  )[0];
  const keysInfoUser = [
    {
      key: "customer_document_number",
      value: infoUser?.doc_number,
    },
    {
      key: "customer_firstname",
      value: infoUser?.first_name,
    },
    {
      key: "customer_email",
      value: infoUser?.email,
    },
    {
      key: "customer_lastname",
      value: infoUser?.last_name,
    },
    {
      key: "customer_number_phone",
      value: infoUser?.phone_number,
    },
    {
      key: "customer_document_type",
      value: {
        id: document?.id,
        name: document?.name,
      },
    },
  ];

  keysInfoUser.forEach((u) => setValue(u.key, u.value));
  setInputValue(document?.name);
};
